import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ManageBoxesIcon from '@mui/icons-material/Dns';
import ManagePatientsIcon from '@mui/icons-material/SupervisorAccount';
import ManageUsersIcon from '@mui/icons-material/AccountBox';
import ManageAccountsIcon from '@mui/icons-material/AccountBalance';
import List from '@mui/material/List';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Link } from "@reach/router";
import USER_ROLES from '../common/userroles';
import ConsoleIcon from '@mui/icons-material/IndeterminateCheckBox';
import Report from './Report';
import { Divider } from '@mui/material';
// import EventIcon from '@mui/icons-material/Event';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { withTranslation } from 'react-i18next';
import GroupsIcon from '@mui/icons-material/Groups';
import AttributionIcon from '@mui/icons-material/Attribution';

const styles = theme => ({
  root: {
    width: '100%',
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
  nested: {
    paddingLeft: theme.spacing.unit * 4,
  },
  textColor:{
    color: 'black',
  },
  listItem:{
    '&.MuiButtonBase-root': {
      display: 'flex',
      padding: '8px 24px 8px 24px'
    }
  }
});

class MenuList extends React.Component {
  state = {
    open: false,
    rolepermissionmenu: false,
    DeliveryTech: false,
    DeliveryTechReports: true,
    notification: false,
  };
  handleClick = () => {
    this.setState(state => ({ open: !state.open }));
  };
  componentDidMount() {
    let role = JSON.parse(sessionStorage.getItem('superadmin'));
    if (role === USER_ROLES.SUPERADMIN) {
      this.setState({ rolepermissionmenu: true, notification: true });
    }
    let permissionUser = JSON.parse(sessionStorage.getItem('permissionUser'));
    if (permissionUser === USER_ROLES.DELIVERYTECH) {
      this.setState({ DeliveryTech: true })
    }
  }
  componentWillUnmount() {
    this.setState({ notification: false })
  }

  render() {
    const { classes, t } = this.props;
    const currentLang = localStorage.getItem('i18nextLng');
    const _isRetail = localStorage.getItem('isRetail');
    return (
      <div id='react-no-print'>
        {this.state.DeliveryTech ? (
          <div>
            <Link to="/home/manage/console" style={{ textDecoration: 'none' }}>
              <ListItemButton className={classes.listItem}>
                <ListItemIcon>
                  <ConsoleIcon />
                </ListItemIcon>
                <ListItemText primary={t("Leftbar.Console")} className={classes.textColor}/>
              </ListItemButton>
            </Link>
            <Divider />
            <Report />
          </div>
        )
          :
          (
            <div>
              <Link to="/home/manage/locations" style={{ textDecoration: 'none' }}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <ManageBoxesIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Leftbar.ManageLocation")} className={classes.textColor}/>
                </ListItemButton>
              </Link>
              <Link to={[false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) ? "/home/manage/patients" : "/home/manage/customers"} style={{ textDecoration: 'none' }}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <ManagePatientsIcon />
                  </ListItemIcon>
                  <ListItemText primary={ [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) ? t("Leftbar.ManagePatient") : t("Leftbar.ManageCustomers") } className={classes.textColor}/>
                </ListItemButton>
              </Link>
              <Link tag="a" to="/home/manage/users/0" style={{ textDecoration: 'none' }}>
                <ListItemButton onClick={this.handleClick} className={classes.listItem}>
                  <ListItemIcon>
                    <ManageUsersIcon />
                  </ListItemIcon>
                  <ListItemText inset primary={t("Leftbar.ManageUsers")} className={classes.textColor} style={{paddingLeft:'0px'}}/>
                  {this.state.rolepermissionmenu === true ? (this.state.open ? (<ExpandLess className={classes.textColor}/>) : (<ExpandMore className={classes.textColor}/>)) : ('')}
                </ListItemButton>
                {this.state.rolepermissionmenu === true ? (
                  <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                    <Link to="/home/user-role/rolepermissions" style={{ textDecoration: 'none' }}>
                      <List component="div" disablePadding>
                        <ListItemButton className={classes.listItem}>
                          <ListItemText inset primary={t("Leftbar.RolePermissions")} className={classes.textColor}/>
                        </ListItemButton>
                      </List>
                    </Link>
                  </Collapse>) : ('')}
              </Link>
              {
                JSON.parse(localStorage.getItem('isIlocalUser')) &&  [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) ? (
                  <Link tag="a" to="/home/manage/vendors" style={{ textDecoration: 'none' }}>
                    <ListItemButton className={classes.listItem}>
                      <ListItemIcon>
                        <ManageUsersIcon />
                      </ListItemIcon>
                      <ListItemText inset primary={t("Leftbar.ManageVendors")} className={classes.textColor} style={{ paddingLeft: '0px' }} />
                    </ListItemButton>
                  </Link>
                ) : null
              }
              <Link to="/home/manage/groups" style={{ textDecoration: 'none' }}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <GroupsIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Groups.ManageGroupsTitle")} className={classes.textColor}/>
                </ListItemButton>
              </Link>
              <Link to="/home/manage/roles" style={{ textDecoration: 'none' }}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <AttributionIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Roles.ManageRolesTitle")} className={classes.textColor}/>
                </ListItemButton>
              </Link>
              <Link to="/home/manage/accounts" style={{ textDecoration: 'none' }}>
                <ListItemButton className={classes.listItem}>
                  <ListItemIcon>
                    <ManageAccountsIcon />
                  </ListItemIcon>
                  <ListItemText primary={t("Leftbar.ManageAccounts")} className={classes.textColor}/>
                </ListItemButton>
              </Link>
              {(currentLang === 'en' && [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail)) &&
                <Link to="/home/manage/console" style={{ textDecoration: 'none' }}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <ConsoleIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Console")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              }
              {[false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail) &&
                <Link to="/home/manage/releaseHistory" style={{ textDecoration: 'none' }}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <NotificationsIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Announcement")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              }
              {/* {(currentLang === 'en' && [false, 'false', undefined, 'undefined', null, 'null', ''].includes(_isRetail)) &&
                <Link to="/home/manage/appointment" style={{ textDecoration: 'none' }}>
                  <ListItemButton className={classes.listItem}>
                    <ListItemIcon>
                      <EventIcon />
                    </ListItemIcon>
                    <ListItemText primary={t("Leftbar.Appointment")} className={classes.textColor} />
                  </ListItemButton>
                </Link>
              } */}
            </div>
          )
        }
      </div>
    );
  }
}

MenuList.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(withTranslation()(MenuList));



// WEBPACK FOOTER //
// ./src/components/leftnav/Managemenulink.js